import React, { Component } from 'react';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class SearchResultsPagination extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.state = {
            pageRangeDisplay: 3
        };
    }

    nextPage() {
        const { searchPagination, actions } = this.props;
        actions.applyPagination(searchPagination + 1).then((data)=>{
            this.changeToPage(data);
        });
    }

    prevPage() {
        const { searchPagination, actions } = this.props;
        actions.applyPagination(searchPagination - 1).then((data)=>{
            this.changeToPage(data);
        });
    }

    changeToPage(val) {
        const { requestData, pageNumber } = this.props;
        if (pageNumber !== val) {
            const req = {
                ...requestData,
                pageNumber: val
            };
            this.props.actions.getHotelAvailabilityXmlRequest(req);
        }
    }

    render() {
        const { pageNumber, pageSize, totalItemCount } = this.props;
        const { pageRangeDisplay } = this.state;
        const pagesNumbers = [];
        const totalNumberOfPages = Math.ceil(totalItemCount / pageSize);
        for (let i = 1; i <= totalNumberOfPages; i++) {
            pagesNumbers.push(i);
        }

        const pageDisplayNumbers = pagesNumbers.map((n) => {
            if (n - pageNumber >= -Math.abs(pageRangeDisplay) && n - pageNumber <= pageRangeDisplay) {
                return (
                    <button
                        type="button"
                        className="tsp-page-number"
                        onClick={this.changeToPage.bind(this, n - 1)}
                        disabled={pageNumber + 1 === n}>
                        {n}
                    </button>
                );
            }
        });

        const extraIndicator = totalNumberOfPages > pageRangeDisplay;

        return (
            <div className="travco-search-pagination-wrapper">
                <button type="button" className="tsp-previous-page" onClick={this.prevPage} disabled={pageNumber === 0}>
                    Previous
                </button>
                {(extraIndicator && pageNumber > Math.round(pageRangeDisplay/2))  && <span className="tsp-page-number">...</span>}
                {pageDisplayNumbers}
                {extraIndicator && totalNumberOfPages - pageNumber > pageRangeDisplay/2 && <span className="tsp-page-number">...</span>}
                <button type="button" className="tsp-next-page" onClick={this.nextPage} disabled={pageNumber + 1 === totalNumberOfPages}>
                    Next
                </button>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        requestData: state.xml?.requestHAData,
        pageNumber: state.xml?.requestHAData?.pageNumber,
        pageSize: state.xml?.requestHAData?.pageSize,
        totalItemCount: state.xml?.totalItemCount,
        searchPagination: state.searchPagination
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsPagination);
